module.exports = __webpack_public_path__ + "static/Balor-f01b3d4b2aa7af07a50b62b61f075baf.jpg";